import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiManager from "../../api/ApiManager.tsx";
import { BillingAddress, ShippingAddress } from "./userSlice.types.ts";

// Asynchronous actions
export const fetchInit = createAsyncThunk('cart/fetchInit', async () => {
    return await ApiManager.fetchInitData();
});

export const login = createAsyncThunk('login', (formData: FormData, { rejectWithValue }) => ApiManager.login(formData, rejectWithValue));

export const logout = createAsyncThunk('logout', () => ApiManager.logout());

export const changeCurrency = createAsyncThunk('changeCurrency', (currency: string) => ApiManager.changeCurrency(currency));

const userSlice = createSlice({
    name: 'user',
    initialState: {
        auth: {
            modalShow: false as boolean,
            errorInfo: null as null | string,
            loading: false as boolean
        },
        language: 'en',
        currency: 'PLN',
        billingAddress: {} as BillingAddress,
        billingAddressFormErrors: {} as BillingAddress,
        deliveryAddressFormErrors: {} as ShippingAddress,
        countriesOptions: {} as { [key: string]: string },
        loaded: false,
        logged: null as null | boolean,
        reseller: null as null | number,
        resellerV1: null as null | boolean,
        resellerOptions: null as null | { shortCode: string; currency: string },
        balance: null as null | number,
        balanceLow: null as null | number,
        balanceMiddle: null as null | number,
        timeToShipment: null as null | number,
        firstName: '' as string,
        lastName: '' as string,
        email: '' as string,
        nip: '' as string,
        company: '' as string,
        phone: '' as string,
        advancedOrderStatus: null as null | boolean,
        resellerOrderDetailsButtons: null as null | boolean,
        resellerOrderDetailsNotes: null as null | boolean,
        admin: null as null | boolean,
        resellerInfo: null as null | { type: number, id: string }
    },
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setCurrency: (state, action) => {
            state.currency = action.payload;
        },
        setBillingAddress: (state, action) => {
            state.billingAddress = action.payload
        },
        setBillingAddressFormErrors: (state, action) => {
            state.billingAddressFormErrors = action.payload;
        },
        setDeliveryAddressFormErrors: (state, action) => {
            state.deliveryAddressFormErrors = action.payload;
        },
        setAuthLoading: (state, action) => {
            state.auth.loading = action.payload
        },
        setModalShow: (state, action) => {
            state.auth.modalShow = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInit.fulfilled, (state, action) => {
                const user = action.payload.user;

                state.loaded = true;
                state.language = action.payload.lang;
                state.currency = action.payload.currency;
                state.logged = (action.payload.user !== null);
                if (state.logged) {
                    state.reseller = action.payload.user.reseller;
                    state.resellerInfo = action.payload.user.resellerInfo;
                    state.admin = action.payload.user?.admin;
                    state.resellerV1 = action.payload?.user?.resellerV1;
                    state.resellerOptions = action.payload.reseller ? {
                        shortCode: action.payload.reseller.shortCode,
                        currency: action.payload.reseller.currency
                    } : null;

                    state.billingAddress = {
                        country: action.payload.country,
                        company: user?.company,
                        nip: user?.nip,
                        firstName: user?.firstName,
                        lastName: user?.lastName,
                        street: user?.address.street,
                        house: user?.address.firstNumber,
                        apartment: user?.address.secondaryNumber,
                        postalCode: user?.address.postCode,
                        city: user?.address.city,
                        email: user?.email,
                        phone: user?.phone,
                    } as BillingAddress;


                    state.balance = action.payload.user.balance;
                    state.balanceMiddle = action.payload.user.balanceMiddle;
                    state.balanceLow = action.payload.user.balanceLow;

                    state.timeToShipment = action.payload.user.timeToShipment;

                    state.firstName = action.payload.user.firstName;
                    state.lastName = action.payload.user.lastName;
                    state.email = action.payload.user.email;
                    state.nip = action.payload.user.nip;
                    state.company = action.payload.user.company;
                    state.phone = action.payload.user.phone;
                }
                state.countriesOptions = action.payload.config.countries;

                state.advancedOrderStatus = action.payload.options.advancedOrderStatus;
                state.resellerOrderDetailsButtons = action.payload.options.resellerOrderDetailsButtons;
                state.resellerOrderDetailsNotes = action.payload.options.resellerOrderDetailsNotes;
            })
            .addCase(login.rejected, (state, action) => {
                if (action.payload) state.auth.errorInfo = action.payload as string;
                state.auth.loading = false;
            })
            .addCase(login.fulfilled, (state, action) => {
                if (action.payload.error === 0) state.auth.errorInfo = null;
                state.auth.loading = false;
                fetchInit();
                window.location.reload();
            })
        /* .addCase(changeCurrency.fulfilled, () => {
            window.location.reload();
        }) */
        /* .addCase(logout.rejected, () => {
            window.location.reload();
        }) */
    },
});

export const {
    setLanguage,
    setCurrency,
    setBillingAddress,
    setBillingAddressFormErrors,
    setDeliveryAddressFormErrors,
    setAuthLoading,
    setModalShow
} = userSlice.actions;
export default userSlice.reducer;